/**
 * The one mime-to-extension map for huddle audio (h1h2-plan.md 1.9, R-E).
 *
 * The SQL side is public.huddle_audio_ext in the M2 migration; the two are
 * tied by audioFormat.test.ts, which reads that migration as text. Change one
 * and that test goes red until the other matches.
 *
 * Only BARE types are ever sent: the upload's contentType, the mime argument
 * of record_huddle_chunk and the key looked up here. A browser that records
 * 'audio/webm;codecs=opus' sends 'audio/webm'.
 */
export const AUDIO_EXT = {
  'audio/webm': 'webm',
  'audio/ogg': 'ogg',
  'audio/mp4': 'm4a',
} as const;

export type BareAudioMime = keyof typeof AUDIO_EXT;

/** What the recorder asks MediaRecorder for, first supported wins (plan 2.2). */
export const RECORDER_MIME_PREFERENCE = [
  'audio/webm;codecs=opus',
  'audio/ogg;codecs=opus',
  'audio/mp4',
] as const;

/** Drops everything from the first ';' and lower-cases: 'audio/webm;codecs=opus' -> 'audio/webm'. */
export function bareMime(type: string): string {
  const cut = type.indexOf(';');
  return (cut === -1 ? type : type.slice(0, cut)).trim().toLowerCase();
}

/** The bare type when it is one of the three the server accepts, else null. */
export function acceptedMime(type: string): BareAudioMime | null {
  const bare = bareMime(type);
  return Object.prototype.hasOwnProperty.call(AUDIO_EXT, bare) ? (bare as BareAudioMime) : null;
}

/** Storage object name for one piece: pieces/<huddle>/<seat>/<seq>.<ext> (plan 1.4, 2.4). */
export function piecePath(
  huddleId: string,
  participantId: string,
  seq: number,
  mime: BareAudioMime,
): string {
  return `pieces/${huddleId}/${participantId}/${seq}.${AUDIO_EXT[mime]}`;
}
